import { render, staticRenderFns } from "./IbxCreateAssessmentModal.vue?vue&type=template&id=e8193dac"
import script from "./IbxCreateAssessmentModal.vue?vue&type=script&lang=js"
export * from "./IbxCreateAssessmentModal.vue?vue&type=script&lang=js"
import style0 from "./IbxCreateAssessmentModal.vue?vue&type=style&index=0&id=e8193dac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports